import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Avatar as Avatar$1 } from '../Avatar/Avatar.es.js';
var Avatar = styled(Avatar$1).withConfig({
  componentId: "u3rv81-0"
})([""]);
var avatarWrapperMask = variant({
  prop: "size",
  variants: {
    sm: {
      maskImage: "radial-gradient(ellipse 120px 100px at -20px center, #0000 30px, #000 30.5px)"
    },
    md: {
      maskImage: "radial-gradient(ellipse 120px 110px at -20px center, #0000 30px, #000 30.5px)"
    },
    lg: {
      maskImage: "radial-gradient(ellipse 120px 130px at -20px center, #0000 30px, #000 30.5px)"
    }
  }
});
var AvatarWrapper = styled(Box).withConfig({
  componentId: "u3rv81-1"
})(["display:flex;align-items:center;flex-direction:row;position:relative;&:hover:not(:disabled){text-decoration:none;}&:not(:first-child){margin-left:-7px;", "{", ";}}&:hover{z-index:100;", "{mask-image:initial;}}"], Avatar, avatarWrapperMask, Avatar);
export { Avatar, AvatarWrapper };